<div id="google_translate_element"></div>

<!-- <ng-container #logoContainer>
  <button class="btn-select" (click)="handleClickTogglenOptions()">
    <img [src]="'../../../assets/images/' + currentLang + '-icon.svg'" alt="Language Icon">
  </button>
  <ul *ngIf="showLanguages">
    <li *ngIf="language() != 'pt-br'">
      <button (click)="changeLanguage('pt-br')">
        <img src="../../../assets/images/pt-br-icon.svg" alt="Brazil icon">
        <span>{{ 'Português (Brasil)' }}</span>
      </button>
    </li>
    <li *ngIf="language() != 'en'">
      <button (click)="changeLanguage('en')">
        <img src="../../../assets/images/en-icon.svg" alt="USA icon">
        <span>{{ 'Inglês (USA)' }}</span>
      </button>
    </li>
    <li *ngIf="language() != 'es'">
      <button (click)="changeLanguage('es')">
        <img src="../../../assets/images/es-icon.svg" alt="Spain icon">
        <span>{{ 'Espanhol (Espanha)' }}</span>
      </button>
    </li>
  </ul>
</ng-container> -->
